import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CookiebotUser } from '../models';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class CookiebotUserService {
  constructor(private http: HttpClient) { }

  public saveConsentLogger(body: CookiebotUser): Observable<any> {
    const apiUrl = 'v5/secm/audit/log';
    return this.http.post(apiUrl, body);
  }
}
